import axios from "axios";
import { useEffect, useState } from "react";
import { Parking } from "../types/Parking";

export const useParking = () => {
  const [parking, setParking] = useState<Parking[]>([]);

  const nodeServerBaseUrl =
    process.env.REACT_APP_NODE_SERVER_BASE_URL ||
    "https://aspiria-prod-api.azurewebsites.net/api/v1";

  useEffect(() => {
    axios
      .get(`${nodeServerBaseUrl}/parking/`)
      .then((response) => {
        setParking(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [nodeServerBaseUrl]);

  return {
    parking,
  };
};
